export default "__VITE_ASSET__860cf5c4__"